import React from "react";
import { Grid, Container, Box, Card } from '@mui/material';
import { Fade } from "react-awesome-reveal";

const Testimonials = ({ data, parseContent }) => {
  const { cards }  = data || [];
  return (
    <Card id="Testimonials">
      <div className="testimonial-one-bg"/>
      <Container className="container" sx={{p:{xs:0, lg : 2}}}>
        <div className="section-title text-center">
        <h2>{data ? data.title : "...loading"}</h2>
        </div>
         <Fade cascade damping={1}>
            <Grid  container className="portfolio-items row" spacing={0}>
              {cards?.length
              ? cards.map((d, i) => (
                  <Grid item key={`${d.name}-${i}`} md={4}>
                    <div className="testimonial">
                      <div className="testimonial-image">
                        <img src={`${process.env.REACT_APP_PUBLIC_URL}/img/testimonials/${d.img}`} alt="" />{" "}
                      </div>
                      <div className="testimonial-content">
                        <Box style={{ textAlign:"justify"}}>{parseContent(d.text.substring(0,150))}</Box>
                        <div className="testimonial-meta"> - {d.title} </div>
                      </div>
                    </div>
                  </Grid>
                ))
              : "loading"}
            </Grid>
          </Fade>
      </Container>
    </Card>
  );
};

export default Testimonials